import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

export const Container = styled.div`
  padding: 24px 43px;
  display: flex;
  flex-direction: column;
`;

export const CreateContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  padding-bottom: 12px;
  padding-left: 13px;
  padding-right: 11px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-left: 46px;
    padding-right: 0;
    margin-top: 0;
    padding-bottom: 0;
  }
`;

export const StyledForm = styled.form`
  @media ${theme?.breakpoints?.sm_up} {
    width: 100%;
  }
  & .heading {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
    & .delete {
      height: 20px;
      width: 20px;
      margin-bottom: 15px;
      cursor: pointer;
      @media ${theme?.breakpoints?.sm_up} {
        margin: 34px 0 21px 0;
      }
    }
  }
`;

export const Subheading = styled.div`
  float: right;
  margin-bottom: 5px;
  & a {
    margin-left: 10px;
    font-family: ${theme.fonts.primaryFontSemiBold};
    color: ${COLORS.BTN_GREEN};
    text-decoration: underline;
    cursor: pointer;
    transition: color 0.2s ease;
    &:hover {
      color: #006970;
    }
  }
`;

export const FormLabel = styled.div`
  display: flex;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 12px;
  line-height: 1.7;
  color: ${COLORS.INPUT_LABEL};
  letter-spacing: 0.4px;
  margin-bottom: 5px;
  font-weight: 700;
`;

export const StyledFormElementsWrapper = styled.div`
  margin-bottom: 20px;
  max-width: ${({ width }) => (width ? width : "100%")};
  background: #ffffff;
  border-radius: 20px;
  padding: 32px;
  box-shadow:
    0 4px 20px rgba(0, 131, 140, 0.08),
    0 1px 4px rgba(0, 0, 0, 0.04);
  transition:
    box-shadow 0.3s ease,
    transform 0.2s ease;
  border: 1.5px solid rgba(0, 131, 140, 0.12);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    box-shadow:
      0 8px 32px rgba(0, 131, 140, 0.14),
      0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
    &::before {
      opacity: 1;
    }
  }

  & .link {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
  }
  & .template {
    margin-top: 0px;
  }
  & .waring-msg {
    color: ${COLORS.WARNING};
    font-size: 10px;
    white-space: nowrap;
  }
  & .mediator-type {
    .MuiFormGroup-root {
      display: flex;
      flex-direction: column !important;
      & .MuiFormControlLabel-root {
        padding: 10px 0px;
      }
    }
  }
  @media ${theme?.breakpoints?.sm_down} {
    padding: 20px;
    & .template {
      margin-top: 15px;
    }
  }
`;

export const HyperLink = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.BTN_GREEN};
  text-decoration: underline;
  cursor: pointer;
  display: table;
  font-size: 14px;
  width: 100%;
  transition: color 0.2s ease;
  &:hover {
    color: #006970;
  }
  @media (min-width: 780px) {
    font-size: 12px;
    width: auto;
  }
`;

export const Button = styled.div`
  width: 50%;
`;

export const CheckboxGrid = styled.div`
  @media ${theme?.breakpoints?.sm_up} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 0px;
  }
`;

export const ContainerGrid = styled.div`
  @media ${theme?.breakpoints?.sm_up} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
`;

export const LableContainer = styled.div`
  & .agent_row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 3px 0px;
    & .agent_name {
      font-size: 16px;
      font-weight: 600;
      flex: 1;
      color: ${COLORS.COLOR_DARK};
      font-family: ${theme.fonts.primaryFontSemiBold};
    }
    & .agent_email {
      font-size: 16px;
      font-weight: 600;
      flex: 1;
      color: ${COLORS.TRANSCRIPT_GRAY};
      font-family: ${theme.fonts.primaryFontSemiBold};
    }
    & .add_circle {
      margin: 0px 20px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 131, 140, 0.13);
      cursor: pointer;
      & .add_icon {
        font-size: 14px;
        color: ${COLORS.BTN_GREEN};
      }
    }
  }
`;

/* ── NEW: Operation selector card ── */
export const OperationSelectorCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 28px 32px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(0, 131, 140, 0.08);
  border: 1.5px solid rgba(0, 131, 140, 0.12);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
  }
`;

export const OperationLabel = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 13px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 8px;

  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, rgba(0, 131, 140, 0.2), transparent);
  }
`;

export const OperationChipsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const OperationChip = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  border: 1px solid
    ${({ selected }) => (selected ? COLORS.BTN_GREEN : "#e1e3ee")};
  background: ${({ selected }) =>
    selected
      ? "linear-gradient(135deg, rgba(0,131,140,0.08), rgba(105,227,194,0.12))"
      : "#f8faff"};
  transition: all 0.25s ease;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${({ selected }) => (selected ? COLORS.BTN_GREEN : COLORS.COLOR_DARK)};
  font-weight: ${({ selected }) => (selected ? "700" : "500")};
  box-shadow: ${({ selected }) =>
    selected ? "0 4px 12px rgba(0,131,140,0.2)" : "0 1px 4px rgba(0,0,0,0.06)"};

  &:hover {
    border-color: ${COLORS.BTN_GREEN};
    background: linear-gradient(
      135deg,
      rgba(0, 131, 140, 0.06),
      rgba(105, 227, 194, 0.1)
    );
    color: ${COLORS.BTN_GREEN};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 131, 140, 0.18);
  }

  input[type="radio"] {
    display: none;
  }
`;

export const ChipDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ selected }) => (selected ? COLORS.BTN_GREEN : "#c5cde2")};
  transition: background 0.2s ease;
  flex-shrink: 0;
`;

export const ActionButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
  padding: 24px 32px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 131, 140, 0.08);
  border: 1.5px solid rgba(0, 131, 140, 0.12);
`;
